<template>
    <v-container>
        <v-row>
            <v-col cols="12" md="8" offset-md="2">
                <v-timeline>
                    <v-timeline-item
                    v-for="(data, i) in datos"
                    :key="i"
                    :color=" data.color == '' ? 'primary' : data.color"
                    small
                    >
                    <template v-slot:opposite>
                        <span
                        v-text="data.fecha"
                        ></span>
                    </template>
                     <v-card>
                        <v-card-title class="py-1">
                            <h6>{{data.concepto}}</h6>
                        </v-card-title>
                        <v-card-text class="text--primary px-0">
                            <p class="mx-5 mb-0">{{ data.dias }} Dias</p>
                        </v-card-text>
                     </v-card>
                    </v-timeline-item>
                </v-timeline> 
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-card>
                    <v-card-title>
                    
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers"
                                item-key="nrreporte"
                                :loading="show"
                                loading-text="Cargando... espere un momento"
                                no-data-text="No hay datos disponibles"
                                :search="search"
                                :items="expediente"
                                :footer-props="{
                                                  'items-per-page-options': [20, 50, 100],
                                                  'items-per-page-text':'Registros por página'
                                                }">>
                        <template v-slot:[`item.nrreporte`]="{item}">
                            <a v-on:click="BuscarReporte(item);">{{ item.nrreporte }}</a>
                        </template>
                    </v-data-table>
                </v-card>
            
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import services from '@/services/TramitePago/TramitePago.Service.js';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

    export default {
        title() {
            return this.$route.meta.title
        },
        data: function () {
            return {
                reverse: true,
                valid: true,
                datos: [],
                contador: 0,
                show: true,
                search: '',
                expediente: [],
                headers: [
                    { text: 'Concepto', value: 'cexconcepto', class: "text title" },
                    { text: 'Respuesta', value: 'xpresp', class: "text title" },
                    { text: 'Observación', value: 'xpobservacion', class: "text title" },
                    { text: 'Fecha', value: 'xpfecha', class: 'text title' },
                    { text: 'Uslogin', value: 'uslogin', class: "text title" },
                ],
                reporte: {},
            }
        },
        computed: {
            ...mapState([
                "domain",
                "informationPage",
                "paginacion",
                "permission",
                "user"
            ])
        },
        methods: {
            MovimientoTramite() {
                this.$router.push({ name: `AgregarMovimiento` });
            },
            async BuscarMovimientoExpediente() {
                let formData = new FormData();
                formData.append("nrreporte", this.reporte.nrreporte);
                formData.append("svindice", this.reporte.svindice);
                Honorario.BuscarMovimientoExpediente(this, formData).then(data => {
                    if (data[0].Column1 == 1)
                        this.visual = true;
                });
            },
            async ObtenerLienaTiempo(){
                let formData = new FormData();
                formData.append("reporte", this.reporte.nrreporte);
                formData.append("indice", this.reporte.svindice);
                services.LineaTiempo(this,formData).then(data =>{
                    this.expediente = data;
                    this.show = false;
                });
            },
            async LineaTiempoEstado(){
                let formData = new FormData();
                formData.append("reporte", this.reporte.nrreporte);
                formData.append("indice", this.reporte.svindice);
                services.LineaTiempoEstado(this,formData).then(data =>{
                    this.datos = data;
                    this.contador = data.length;
                });
            }
        },
        async mounted() {
            this.reporte = await MetodosGenerales.obtenerSessionReporte('reporte');
            this.LineaTiempoEstado();
            this.ObtenerLienaTiempo();
        }
    }
</script>
<style>
    .errror {
        border: 2px solid red;
    }

    .v-timeline::before {
        top: 55px;
        height: calc(100% - 110px)
    }
</style>